import { render } from "./BorderLeftAlert.vue?vue&type=template&id=d2b46744&scoped=true"
const script = {}

import "./BorderLeftAlert.vue?vue&type=style&index=0&id=d2b46744&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2b46744"]])

export default __exports__